/* Supply2Consume Shopify theme — AJAX Cart API wiring (mini-cart drawer + badge) */

(function () {
  function updateCartBadge(itemCount) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = itemCount;
      el.style.display = itemCount > 0 ? "flex" : "none";
    });
  }

  function cartItemRowHTML(item, index) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, "_200x$1$2") + '" alt="' + Theme.escape(item.product_title) + '">'
      : '<svg class="icon"><use href="#icon-image"></use></svg>';
    return (
      '<div class="cart-drawer-item" data-line="' + (index + 1) + '">' +
        '<div class="cart-thumb">' + img + '</div>' +
        '<div class="cart-drawer-item-info">' +
          '<h4><a href="' + Theme.escape(item.url) + '" style="color:inherit;">' + Theme.escape(item.product_title) + '</a></h4>' +
          (item.variant_title ? '<span>' + Theme.escape(item.variant_title) + '</span>' : "") +
          '<div class="cart-qty">' +
            '<button type="button" data-cart-decrease><svg class="icon"><use href="#icon-minus"></use></svg></button>' +
            '<input type="text" readonly value="' + item.quantity + '">' +
            '<button type="button" data-cart-increase><svg class="icon"><use href="#icon-plus"></use></svg></button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-drawer-item-col">' +
          '<span class="cart-drawer-item-price">' + Theme.formatMoney(item.final_line_price) + '</span>' +
          '<div class="cart-remove" style="margin-top:0;" data-cart-remove><svg class="icon"><use href="#icon-trash"></use></svg></div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById("cart-drawer-body");
    var footer = document.getElementById("cart-drawer-footer");
    var countEl = document.getElementById("drawer-count");
    if (!body) return;
    if (countEl) countEl.textContent = cart.item_count;

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cart-drawer-empty"><svg class="icon"><use href="#icon-cart"></use></svg>' +
        '<p>Your cart is empty.</p></div>';
      if (footer) footer.style.display = "none";
      return;
    }
    if (footer) footer.style.display = "flex";

    body.innerHTML = cart.items.map(cartItemRowHTML).join("");
    var subtotalEl = document.getElementById("drawer-subtotal");
    if (subtotalEl) subtotalEl.textContent = Theme.formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetchCart().then(function (cart) {
      updateCartBadge(cart.item_count);
      if (document.getElementById("cart-drawer")) renderCartDrawer(cart);
      return cart;
    });
  }

  Theme.openCartDrawer = function () {
    var drawer = document.getElementById("cart-drawer");
    var overlay = document.getElementById("cart-drawer-overlay");
    if (!drawer || !overlay) return;
    refreshCart();
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    overlay.classList.add("visible");
  };

  Theme.closeCartDrawer = function () {
    var drawer = document.getElementById("cart-drawer");
    var overlay = document.getElementById("cart-drawer-overlay");
    if (!drawer || !overlay) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    overlay.classList.remove("visible");
  };

  Theme.addToCart = function (variantId, quantity, onDone) {
    quantity = quantity || 1;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        return refreshCart();
      })
      .then(function (cart) {
        Theme.openCartDrawer();
        if (onDone) onDone(null, cart);
        return cart;
      })
      .catch(function (err) {
        if (onDone) onDone(err);
        else console.error("Add to cart failed", err);
      });
  };

  function changeLine(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        renderCartDrawer(cart);
        return cart;
      });
  }

  document.addEventListener("DOMContentLoaded", function () {
    refreshCart();

    var body = document.getElementById("cart-drawer-body");
    if (!body) return;

    body.addEventListener("click", function (e) {
      var row = e.target.closest("[data-line]");
      if (!row) return;
      var line = parseInt(row.dataset.line, 10);
      var input = row.querySelector(".cart-qty input");
      var qty = parseInt(input.value, 10) || 1;

      if (e.target.closest("[data-cart-increase]")) changeLine(line, qty + 1);
      else if (e.target.closest("[data-cart-decrease]")) changeLine(line, Math.max(0, qty - 1));
      else if (e.target.closest("[data-cart-remove]")) changeLine(line, 0);
    });
  });
})();
